/** Kleine Anzeige-Helfer der API-Statistik. */

export function formatZeitpunkt(wert: string | null | undefined): string {
  if (!wert) return '—';
  const d = new Date(wert.includes('T') || wert.includes('Z') ? wert : `${wert.replace(' ', 'T')}Z`);
  if (Number.isNaN(d.getTime())) return wert;
  return d.toLocaleString('de-DE', {
    timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export function formatTag(wert: string | null | undefined): string {
  if (!wert) return '—';
  const [jahr, monat, tag] = wert.slice(0, 10).split('-');
  return `${tag}.${monat}.${jahr}`;
}

export function formatQuote(quote: number): string {
  return `${Math.round(quote * 100)} %`;
}

/** Veränderung zur Vorperiode — oft wichtiger als der absolute Wert. */
export function deltaAnzeige(aktuell: number, vorher: number): { text: string; richtung: 'auf' | 'ab' | 'gleich' | 'neu' } {
  if (vorher === 0) return aktuell > 0 ? { text: 'neu', richtung: 'neu' } : { text: '±0', richtung: 'gleich' };
  const prozent = Math.round(((aktuell - vorher) / vorher) * 100);
  if (prozent > 0) return { text: `+${prozent} %`, richtung: 'auf' };
  if (prozent < 0) return { text: `${prozent} %`, richtung: 'ab' };
  return { text: '±0 %', richtung: 'gleich' };
}

export function deltaFarbe(richtung: 'auf' | 'ab' | 'gleich' | 'neu', darkMode: boolean): string {
  if (richtung === 'auf' || richtung === 'neu') return darkMode ? 'text-emerald-400' : 'text-emerald-600';
  if (richtung === 'ab') return darkMode ? 'text-red-400' : 'text-red-600';
  return darkMode ? 'text-slate-400' : 'text-slate-500';
}
